import Vue from "vue";
import Vuex from "vuex";

// Modules
import NgoProfile from "@/modules/ngo/ngo-profile/store.js";
import TempNgo from "@/modules/temp-ngo/store.js";
import NgoHome from "@/modules/home/store.js";
import User from "./user";
import Exporter from "./excel";
import Auth from "../modules/auth/store";
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import profile from "@/modules/user-profile/store.js";
import Docs from "@/modules/docs/store.js";
import Globals from "@/modules/globals/store.js";
import AdvancedReports from "@/modules/ministry/pages/advanced-reports/store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Exporter,
    User,
    Auth,
    app,
    NgoProfile,
    TempNgo,
    NgoHome,
    appConfig,
    verticalMenu,
    profile,
    Docs,
    Globals,
    AdvancedReports,
  },
  strict: process.env.DEV,
});
